import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import DataService from "../../../services/data.service";
import { ItemRevisionProps } from '../../../types/IdProps';
import AddProductCategoryPopup from '../Popups/ItemRevision_popup_AddProductCategory';

const ItemRevision_tab_ProductCategories: React.FC<ItemRevisionProps> = ({ itemId, itemRevisionId, itemTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();

    useEffect(() => {
        getTableData();
    }, [itemId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemProductCategories/ByItem/' + itemId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemProductCategories/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'productCategoryId', visible: false },
        { title: 'Category', dataProp: 'productCategory.nameTree', sort: 'asc' },
    ];
    if (isAuthorizedForItemType(ApplicationFunctions.UpdateItem, itemTypeId)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    return (
        <>
            <DataTable
                name='dtItemProductCategories'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Category'
                navigateUrl='/plm/ItemSetup/ProductCategory/'
            />
            {showPopup && <AddProductCategoryPopup itemId={itemId} itemRevisionId={itemRevisionId} itemTypeId={itemTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default ItemRevision_tab_ProductCategories;